/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Export_FailedInputs */

const vi_tea_purchase_export_failed = /** @type {(inputs: Tea_Purchase_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel thất bại`)
};

/**

* @param {Tea_Purchase_Export_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_export_failed = /** @type {((inputs?: Tea_Purchase_Export_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Export_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_export_failed(inputs)
});